"use client";

import AccessController from '@/app/itineraries/(map-layout)/components/AccessController';
import ItineraryOverviewMasqut from "@/components/icons/ItineraryOverviewMasqut";
import { useItineraryStoreV2 } from "@/core/stores/itinerary/itineraryV2";
import useNextRouter from '@/hooks/useNextRouter';
import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";
import ItineraryDay from "./ItineraryDay";


const ItinerarySection = () => {
  const { itineraryDays, baseUrl, setActiveDays, itinerary } = useItineraryStoreV2()

  const { push } = useNextRouter()

  useEffect(() => {
    setActiveDays(itineraryDays.map((i, index) => index))
  }, [itineraryDays])

  return (
    <div className="w-full h-full relative z-50">

      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
          exit={{ opacity: 0, y: 10, transition: { duration: 0.2 } }}
        >
          <div className="min-h-[138px] rounded-2xl p-2 bg-pastel-purple mb-5 !z-20">
            <div className="flex font-medium items-center text-[#364153] gap-3">
              <ItineraryOverviewMasqut />
              Review by PlaninGo
            </div>
            <p className="px-2 pt-2 text-sm text-[#1E2939] line-clamp-2">Discover the magic of Paris with this 4-day itinerary! Each day has a unique theme to guide you through the city’s most famous attractions, hidden gems, and cultural experiences.</p>
            <p className="p-2 text-sm text-[#1E2939]">Show More</p>
          </div>

          <div className="flex items-center justify-between z-20">
            <p className="text-[#1E2939] font-bold text-2xl">Itinerary Overview</p>

            <AccessController allowedRoles={['editor', 'owner']}>
              <button onClick={() => push(baseUrl + `/edit`)}>
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.0376 10.5V12C22.0376 16.714 22.0376 19.0711 20.5731 20.5355C19.1087 22 16.7516 22 12.0376 22C7.32355 22 4.96653 22 3.50206 20.5355C2.0376 19.0711 2.0376 16.714 2.0376 12C2.0376 7.28595 2.0376 4.92893 3.50206 3.46447C4.96653 2 7.32355 2 12.0376 2H13.5376" stroke="#4A5565" strokeWidth="1.5" strokeLinecap="round" />
                  <path d="M16.6896 3.45506L17.3385 2.80624C18.4135 1.73125 20.1564 1.73125 21.2314 2.80624C22.3063 3.88124 22.3063 5.62415 21.2314 6.69914L20.5825 7.34795M16.6896 3.45506C16.6896 3.45506 16.7707 4.83379 17.9873 6.05032C19.2038 7.26685 20.5825 7.34795 20.5825 7.34795M16.6896 3.45506L10.7248 9.41993C10.3208 9.82394 10.1188 10.0259 9.94503 10.2487C9.74009 10.5114 9.56439 10.7957 9.42104 11.0965C9.29951 11.3515 9.20917 11.6225 9.02849 12.1646L8.45002 13.9M20.5825 7.34795L14.6177 13.3128C14.2137 13.7168 14.0116 13.9188 13.7889 14.0926C13.5262 14.2975 13.2419 14.4732 12.9411 14.6166C12.6861 14.7381 12.4151 14.8284 11.873 15.0091L10.1376 15.5876M10.1376 15.5876L9.01469 15.9619C8.74794 16.0508 8.45386 15.9814 8.25504 15.7826C8.05622 15.5837 7.9868 15.2897 8.07571 15.0229L8.45002 13.9M10.1376 15.5876L8.45002 13.9" stroke="#4A5565" strokeWidth="1.5" />
                </svg>
              </button>
            </AccessController>
          </div>

          {/* //////////////////////////// */}
          <div className="flex flex-col gap-y-10 border-dashed border-l-2 border-gray-300 mt-5 z-0 ">
            {itineraryDays.map((itinerary, index) => (
              <ItineraryDay key={itinerary.id} itinerary={itinerary} index={index} />
            ))}
          </div>
          {/* //////////////////////////// */}

        </motion.div>
      </AnimatePresence>
    </div>

  );
};

export default ItinerarySection;
